(function() {
  var BaseForm,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  BaseForm = App.loadClass("grower::viewmodels/prescription_map/Form");

  exports.Form = (function(superClass) {
    extend(Form, superClass);

    Form.prototype.setInitialDeps = function() {
      Form.__super__.setInitialDeps.call(this);
      return this.syncDeps({
        "Layer": 'grower::viewmodels/prescription_map/export/Layer'
      });
    };

    function Form() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      Form.__super__.constructor.apply(this, args);
      this.setInitialDeps();
    }

    Form.prototype.recalcPopulations = function() {
      var msg, obj, old_keep;
      this.layer().was_recalculated(true);
      old_keep = $.merge([], this.layer()._keep_properties);
      $.merge(this.layer()._keep_properties, ['hybrid_id', 'target_population', 'min_population', 'max_population', 'num_populations', 'min_pop_diff', 'max_pop_diff', 'fields_id', 'machinery_id']);
      obj = this.layer().serialize();
      this.layer()._keep_properties = old_keep;
      msg = this.handler.dialog.find('.message_writer');
      msg.message_writer('info', 'Recalculating...');
      return $.post('backend/grower/layers/prescription-map/recalc-populations', {
        json: obj
      }, (function(_this) {
        return function(result) {
          var i, len, p, ref, ref1, s, stage;
          if ((result.data == null) || result.status.type === 'error') {
            msg.message_writer('error', result.status.msg);
            return null;
          }
          ref = result.data.soils;
          for (s in ref) {
            p = ref[s];
            ref1 = _this.layer().stages;
            for (i = 0, len = ref1.length; i < len; i++) {
              stage = ref1[i];
              if (stage.musym === s) {
                stage.population(p);
              }
            }
          }
          if (result.status.type === 'success') {
            msg.message_writer('success', result.status.msg);
            return msg.message_writer('hide');
          } else {
            return msg.message_writer('info', result.status.msg);
          }
        };
      })(this));
    };

    return Form;

  })(BaseForm);

}).call(this);
